/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function e(e,n,r){return n()}export{e as useSyncExternalStore};
//# sourceMappingURL=useSyncExternalStoreShimServer.js.map
